import { RenderDataWithFallback } from '@anytag/shared-atoms';
import { useMarketplaceDetailsContext } from '../marketplace-details-context';
import { useMarketplaceInfluencersWhiteList } from './hooks';
import { MarketplaceInfluencersForOtherUsers } from './marketplace-influencers-for-other-users';
import { MarketplaceInfluencersForAdminStaff } from './marketplace-influencers-for-admin-staff';

export const MarketplaceInfluencers = () => {
  const { loading, influencerWhitelist } = useMarketplaceInfluencersWhiteList();
  const { forceInfluencersParticipateCampaign } = useMarketplaceDetailsContext();

  return (
    <RenderDataWithFallback loading={loading}>
      {influencerWhitelist ? (
        forceInfluencersParticipateCampaign ? (
          <MarketplaceInfluencersForAdminStaff influencerWhitelist={influencerWhitelist} />
        ) : (
          <MarketplaceInfluencersForOtherUsers influencerWhitelist={influencerWhitelist} />
        )
      ) : null}
    </RenderDataWithFallback>
  );
};
